import { mui, React, ts } from '_core';

const StatisticsField = (
  value: ts.enums.REPORT_ENUMS.ANNU_STATISTICS_ENUM,
  setValue: (_v: ts.enums.REPORT_ENUMS.ANNU_STATISTICS_ENUM) => void
) => (
  <mui.core.Box display="inline-flex" width={200} mx={2}>
    <mui.core.TextField
      select
      label="Summary Statistics"
      variant="outlined"
      required
      size="small"
      value={value}
      onChange={(e) => setValue(e.target.value as ts.enums.REPORT_ENUMS.ANNU_STATISTICS_ENUM)}
      fullWidth
    >
      <mui.core.MenuItem value={ts.enums.REPORT_ENUMS.ANNU_STATISTICS_ENUM.RETURNS}>
        Annualized Returns
      </mui.core.MenuItem>
      <mui.core.MenuItem value={ts.enums.REPORT_ENUMS.ANNU_STATISTICS_ENUM.RISK}>Annualized Risk</mui.core.MenuItem>
      <mui.core.MenuItem value={ts.enums.REPORT_ENUMS.ANNU_STATISTICS_ENUM.ADJUSTED}>
        Annualized Risk Adjusted Returns
      </mui.core.MenuItem>
    </mui.core.TextField>
  </mui.core.Box>
);

export default StatisticsField;
